var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrowPagination = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8B0F9BB6-A031-43F3-A2AA-308B2A12843A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS_Wiregrame-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Homepage",
    transform: "translate(-1152.000000, -1118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(855.000000, 1118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Arrow_Pagination",
    transform: "translate(297.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-32",
    fill: "#101820",
    opacity: 0,
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Atoms/Disclosure-Indicator",
    transform: "translate(10.000000, 6.000000)",
    fill: "#40474D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Disclosure-Indicator",
    points: "0 1.92857143 1.6875 0 9 8.35714286 1.6875 16.7142857 0 14.7857143 5.625 8.35714286"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightArrowPagination);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rightArrowPagination.41985f00b9697d0ab1fb77181325d4ed.svg";